/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Display_Customer_PaidInputs */

const vi_customer_display_customer_paid = /** @type {(inputs: Customer_Display_Customer_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách trả`)
};

/**

* @param {Customer_Display_Customer_PaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_display_customer_paid = /** @type {((inputs?: Customer_Display_Customer_PaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Display_Customer_PaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_display_customer_paid(inputs)
});